import { iconIdMapping } from '@arcade/web/icons/react'

import { spacing } from '../../../theme'
import { HeadingElements } from '../../Header/Header'
import { Flex } from '../../layout/Flex'
import Text from '../../Text/Text'

interface Icon {
  arcade_id?: string
}

export interface HeroNumericsHeaderBodyParagraph {
  copy: string
  icon?: Icon
}

export interface HeroNumericsHeaderProps {
  sectionTitle?: string
  title: string
  titleElement: HeadingElements
  bodyParagraph1?: HeroNumericsHeaderBodyParagraph
  bodyParagraph2?: string
  horizontalAlignment?: 'leading' | 'center' | 'trailing'
}

const getAlignItems = (alignment: 'leading' | 'center' | 'trailing'): 'flex-start' | 'center' | 'flex-end' => {
  switch (alignment) {
    case 'leading':
      return 'flex-start'
    case 'trailing':
      return 'flex-end'
    case 'center':
    default:
      return 'center'
  }
}

export default ({
  sectionTitle,
  title,
  titleElement,
  bodyParagraph1,
  bodyParagraph2,
  horizontalAlignment = 'center',
}: HeroNumericsHeaderProps) => {
  // Extract icon component for bodyParagraph1
  const BodyIcon = bodyParagraph1?.icon?.arcade_id ? iconIdMapping[bodyParagraph1.icon.arcade_id]?.Icon : undefined

  return (
    <Flex flexDirection="column" alignItems={getAlignItems(horizontalAlignment)} gap={spacing.xs} as="header">
      {sectionTitle && (
        <Text typography="sectionTitle" color="textStandard" as="h2">
          {sectionTitle}
        </Text>
      )}
      <Text typography="numeralLarge" color="textStandard" as={titleElement}>
        {title}
      </Text>
      {bodyParagraph1 && (
        <Flex gap={spacing.xs} alignItems="center">
          <Text typography="bodyMedium" color="textStandard" as="p">
            {bodyParagraph1.copy}
          </Text>
          {BodyIcon && <BodyIcon size={16} aria-hidden={true} data-testid="hero-numerics-body-icon" />}
        </Flex>
      )}
      {bodyParagraph2 && (
        <Text typography="bodyMedium" color="textStandard" as="p">
          {bodyParagraph2}
        </Text>
      )}
    </Flex>
  )
}
